// utils/withholdingAtc.js
//
// Which 2307s belong on a BUSINESS-TAX SAWT, and the missing-ATC guard.
//
// A SAWT is keyed to the return its credits are claimed against. The two
// business-tax returns take only certificates for business tax withheld at
// source — typically by government payors:
//   2550Q (VAT)            -> WV codes (WV010 goods, WV020 services)
//   2551Q (percentage tax) -> WB codes (e.g. WB080)
// Expanded-withholding 2307s (WC/WI) are income-tax credits and belong on the
// 1701Q/1702Q SAWT. Mixing the two keys the file to the wrong tax type and
// fails BIR cross-matching against the filed returns.

// Mirrors isVatWithholdingAtc in the backend withholding-certificate service.
export const isVatWithholdingAtc = (atcCode) => /^WV/i.test(String(atcCode || '').trim());

export const isPercentageTaxWithholdingAtc = (atcCode) => /^WB/i.test(String(atcCode || '').trim());

/**
 * Names the certificates whose ATC is missing. A blank ATC cannot be routed to
 * either side of the SAWT, so it must block the export — never default it.
 * @param {Array<{name?: string, atcCode?: unknown, certificateNumber?: string}>} records
 * @returns {string[]} display labels, deduped, row order preserved
 */
export function findMissingATCs(records) {
  const seen = new Set();
  const missing = [];
  records.forEach(({ name, atcCode, certificateNumber }, i) => {
    if (String(atcCode ?? '').trim()) return;
    const who = String(name || '').trim() || `(unnamed payee, row ${i + 1})`;
    const label = certificateNumber ? `${who} (certificate ${certificateNumber})` : who;
    if (seen.has(label)) return;
    seen.add(label);
    missing.push(label);
  });
  return missing;
}

/** Human-readable detail for a blocked export. */
export function missingATCMessage(missing) {
  const shown = missing.slice(0, 10);
  const rest = missing.length - shown.length;
  const who = shown.join(', ') + (rest > 0 ? `, and ${rest} more` : '');
  return `Missing ATC on ${missing.length} Form 2307 certificate${missing.length === 1 ? '' : 's'}: ${who}. `
    + 'Set the ATC on each certificate, then export again.';
}
